import { TeamGender } from '@/constants';
import { createSimpleDictionary } from '@/stores/utils/createSimpleDictionary';

export const teamGenderDictionary = createSimpleDictionary([
    { id: TeamGender.Men, name: 'dictionaries.gender.men' },
    { id: TeamGender.Women, name: 'dictionaries.gender.women' },
]);
